module.exports = __webpack_public_path__ + "img/mugimusha_title.22a7bccc.png";